import React, { useEffect } from 'react';
import { func, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { Card } from '@johnlewispartnership/wtr-ingredients/ingredients/Card';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import { appendClientIdParamWhenInWebview } from 'utils/append-client-id-param-when-in-webview';
import { isEmbeddedInWebView } from 'utils/webview';
import urls from 'constants/urls';
import styles from './ForgotPassword.scss';

const Success = ({ email, onUnloadSuccess }) => {
  const isInMobileAppWebView = isEmbeddedInWebView();

  useEffect(() => onUnloadSuccess, [onUnloadSuccess]);

  const registrationLinkProps = isInMobileAppWebView
    ? { component: Link, to: appendClientIdParamWhenInWebview(urls.registration) }
    : { href: urls.tokenClientRegistration };

  return (
    <Card>
      <div className={styles.text}>
        <Typography styleAs="sectionHeading">Reset password email sent</Typography>
        <Typography>
          If an account exists with{' '}
          <span className={styles.mainTextBold} data-cs-mask>
            {email}
          </span>{' '}
          a link to reset your password will be sent.
        </Typography>
        <Typography>
          If you can&apos;t find the email, check your spam folder, or you may need to{' '}
          <TextLink {...registrationLinkProps} className={styles.reRegister}>
            re-register
          </TextLink>
          .
        </Typography>
        {!isInMobileAppWebView && (
          <TextLink
            className={styles.returnToSignIn}
            component={Link}
            id="gotoGLP"
            to={urls.groceriesHome}
          >
            Go to Waitrose Groceries
          </TextLink>
        )}
      </div>
    </Card>
  );
};

Success.propTypes = {
  email: string.isRequired,
  onUnloadSuccess: func.isRequired,
};

export default Success;
